<template>
  <div class="cart-suggest-card">
    <img class="cart-suggest-image" :src="item.thumbnail" alt="product" />
    <p class="cart-suggest-title">{{ item.name }}</p>
    <p class="cart-suggest-price">฿{{ item.price }}</p>
  </div>
</template>

<script>
export default {
  name: 'CartSuggestProductCard',
  props: {
    item: {
      type: Object,
      default: null,
    },
  },
}
</script>

<style lang="scss" scoped>
.cart-suggest-card {
  width: 110px;
  min-width: 110px;
  display: flex;
  flex-direction: column;
  gap: 8px;
  cursor: pointer;
  transition: opacity 0.12s ease;
  &:active {
    opacity: 0.8;
  }
  @media screen and (min-width: 780px) {
    width: 132px;
    min-width: 132px;
    gap: 10px;
  }
}

.cart-suggest-image {
  width: 110px;
  height: 110px;
  border-radius: 10px;
  object-fit: cover;
  background-color: #f5f5f5;
  @media screen and (min-width: 780px) {
    width: 132px;
    height: 132px;
    border-radius: 12px;
  }
}

.cart-suggest-title {
  font-size: 14px;
  font-weight: 500;
  line-height: 1.28;
  min-height: 3.84em;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 3;
  -webkit-box-orient: vertical;
  word-break: break-word;
  color: #161616;
  @media screen and (min-width: 780px) {
    font-size: 14px;
    min-height: 4.2em;
  }
}

.cart-suggest-price {
  font-size: 16px;
  line-height: 1;
  font-weight: 700;
  color: #fd6868;
  margin-top: auto;
  @media screen and (min-width: 780px) {
    font-size: 16px;
  }
}
</style>
